import RejectedDocsModal from './RejectedDocsModal';

export default RejectedDocsModal;
